import type { LengthUnit, VolumeUnit, WeightUnit } from "../types/models";

const ML_PER_OZ = 29.5735295625;
const CM_PER_INCH = 2.54;
const KG_PER_LB = 0.45359237;

export function volumeFromMl(valueMl: number, unit: VolumeUnit): number {
  return unit === "oz" ? valueMl / ML_PER_OZ : valueMl;
}

export function volumeToMl(value: number, unit: VolumeUnit): number {
  return Math.round(unit === "oz" ? value * ML_PER_OZ : value);
}

export function formatVolume(valueMl: number, unit: VolumeUnit): string {
  const value = volumeFromMl(valueMl, unit);
  return unit === "oz" ? `${round(value, 1)} oz` : `${Math.round(value)} ml`;
}

export function lengthFromCm(valueCm: number, unit: LengthUnit): number {
  return unit === "inch" ? valueCm / CM_PER_INCH : valueCm;
}

export function lengthToCm(value: number, unit: LengthUnit): number {
  return unit === "inch" ? value * CM_PER_INCH : value;
}

export function weightFromKg(valueKg: number, unit: WeightUnit): number {
  return unit === "lb" ? valueKg / KG_PER_LB : valueKg;
}

export function weightToKg(value: number, unit: WeightUnit): number {
  return unit === "lb" ? value * KG_PER_LB : value;
}

export function formatWeight(valueKg: number, unit: WeightUnit): string {
  const value = weightFromKg(valueKg, unit);
  return unit === "lb" ? `${round(value, 1)} lb` : `${round(value, 1)} kg`;
}

export function round(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}
